import { render, staticRenderFns } from "./MenuItemsListSkeleton.vue?vue&type=template&id=43aabdd5&"
import script from "./MenuItemsListSkeleton.vue?vue&type=script&lang=js&"
export * from "./MenuItemsListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports